// extracted by mini-css-extract-plugin
module.exports = {"signup-popup-icon":"Icon_signup-popup-icon__DolAM"};